"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkEmail = checkEmail;
exports["default"] = void 0;
exports.disableClientContact = disableClientContact;
exports.enableClientContact = enableClientContact;
exports.enablePlatformAccess = enablePlatformAccess;
exports.forgotPassword = forgotPassword;
exports.getAddress = getAddress;
exports.getCurrentUser = getCurrentUser;
exports.getLanguages = getLanguages;
exports.getPasswordStrength = getPasswordStrength;
exports.getQuickLoginToken = getQuickLoginToken;
exports.getUserAddressByEmail = getUserAddressByEmail;
exports.login = login;
exports.preventPlatformAccess = preventPlatformAccess;
exports.quickLogin = quickLogin;
exports.resetPassword = resetPassword;
exports.sendPlatformInvitationEmail = sendPlatformInvitationEmail;
exports.updatePicture = updatePicture;

var _api = _interopRequireWildcard(require("./api"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function getCurrentUser() {
  return _api["default"].get('/api/user/current').then(_api.extractData)["catch"](_api.errorHandler);
}

function getLanguages(userId) {
  return _api["default"].get("/api/user/".concat(userId, "/language")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getAddress(addressId) {
  return _api["default"].get("/api/address/".concat(addressId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getUserAddressByEmail(email) {
  return _api["default"].get("/api/user/address/".concat(email)).then(_api.extractData)["catch"](_api.errorHandler);
}

function checkEmail(_ref) {
  var email = _ref.email,
      id = _ref.id;
  return _api["default"].post('/api/email-check', {
    email: email,
    id: id
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function sendPlatformInvitationEmail(userId) {
  return _api["default"].get("/api/user/".concat(userId, "/send-platform-invitation-email")).then(_api.extractData)["catch"](_api.errorHandler);
}

function preventPlatformAccess(id) {
  return _api["default"].put("/api/user/".concat(id, "/prevent-platform-access")).then(_api.extractData)["catch"](_api.errorHandler);
}

function enablePlatformAccess(id) {
  return _api["default"].put("/api/user/".concat(id, "/enable-platform-access")).then(_api.extractData)["catch"](_api.errorHandler);
}

function disableClientContact(_ref2) {
  var contactId = _ref2.contactId,
      commentPrefix = _ref2.commentPrefix,
      comment = _ref2.comment;
  return _api["default"].put("/api/user/".concat(contactId, "/disable-client-contact"), {
    commentPrefix: commentPrefix,
    comment: comment
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function enableClientContact(_ref3) {
  var contactId = _ref3.contactId,
      commentPrefix = _ref3.commentPrefix,
      comment = _ref3.comment;
  return _api["default"].put("/api/user/".concat(contactId, "/enable-client-contact"), {
    commentPrefix: commentPrefix,
    comment: comment
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function login(data) {
  return _api["default"].post('/api/login', data).then(_api.extractData)["catch"](_api.errorHandler);
}

function quickLogin(token) {
  return _api["default"].post('/api/quick-login', {
    token: token
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function forgotPassword(data) {
  return _api["default"].post('/api/forgot-password', data).then(_api.extractData)["catch"](_api.errorHandler);
}

function resetPassword(data) {
  return _api["default"].post('/api/reset-password', data).then(_api.extractData)["catch"](_api.errorHandler);
}

function getPasswordStrength(password) {
  return _api["default"].post('/api/password-strength', {
    password: password
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getQuickLoginToken(userId) {
  return _api["default"].get('/api/quick-login-token/' + userId).then(_api.extractData)["catch"](_api.errorHandler);
}

function updatePicture(userId, pictureId) {
  return _api["default"].post("/api/user/".concat(userId, "/update-picture"), {
    pictureId: pictureId
  });
}

var api = {
  getCurrentUser: getCurrentUser,
  getLanguages: getLanguages,
  getAddress: getAddress,
  getUserAddressByEmail: getUserAddressByEmail,
  preventPlatformAccess: preventPlatformAccess,
  enablePlatformAccess: enablePlatformAccess,
  sendPlatformInvitationEmail: sendPlatformInvitationEmail,
  login: login,
  quickLogin: quickLogin,
  forgotPassword: forgotPassword,
  resetPassword: resetPassword,
  getPasswordStrength: getPasswordStrength,
  checkEmail: checkEmail,
  updatePicture: updatePicture
};
var _default = api;
exports["default"] = _default;